import { createTheme, responsiveFontSizes } from "@mui/material";
import { Theme, ThemeOptions } from "@mui/material";
import { ConcreteThemeName } from "./ThemeName";

export class AppThemeUtils {
  static createThemes(
    themeOptions: Record<ConcreteThemeName, ThemeOptions>
  ): Record<ConcreteThemeName, Theme> {
    const themes = {} as Record<ConcreteThemeName, Theme>;
    (Object.keys(themeOptions) as ConcreteThemeName[]).forEach((key) => {
      const value = themeOptions[key];
      let theme = createTheme(value);
      theme = responsiveFontSizes(theme);
      themes[key] = theme;
    });

    return themes;
  }
}
